import React, { useEffect } from "react";
import { Control, Controller, SetFieldValue } from "react-hook-form";
import Select, { OnChangeValue } from "react-select";
import { useAuth } from "../../../../auth/context/AuthProvider";

interface PropertySelectComponentProps {
    setValue: SetFieldValue<any>;
    control: Control<any>;
    errors: any;
}

// Tipe untuk opsi di React Select
type OptionType = {
    value: string;
    label: string;
};

const PropertySelectComponent: React.FC<PropertySelectComponentProps> = ({ setValue, control, errors }) => {
    const { user } = useAuth();

    // Buat daftar properti dari user context
    const propertyArray: OptionType[] = Object.entries(user?.properties || {}).map(([id, name]) => ({
        value: id,
        label: name as string,
    }));

    // Definisikan opsi "Select All"
    const selectAllOption: OptionType = { value: "__all__", label: "All Properties" };
    const optionsWithAll = [selectAllOption, ...propertyArray];

    // Efek untuk mengatur nilai awal berdasarkan active_property_id
    useEffect(() => {
        if (user?.active_property_id) {
            setValue("filter.property_id", user.active_property_id);
        }
    }, [user, setValue]);

    return (
        <div>
            <label className="me-2">Current Property:</label>
            {propertyArray.length > 0 ? (
                <Controller
                    name="filter.property_id"
                    control={control}
                    rules={{ required: "Property selection is required" }}
                    render={({ field: { value, onChange } }) => {
                        // `value` adalah string "id1,id2,..."
                        const selectedValues = value ? value.split(",") : [];
                        const isAllSelected = selectedValues.length === propertyArray.length;

                        // const handleChange = (selectedOptions: readonly { value: string; label: string; }[] | null) => {
                        //     if (!selectedOptions) {
                        //         onChange(""); // none selected
                        //         return;
                        //     }

                        //     const selected = selectedOptions.map(opt => opt.value);

                        //     if (selected.includes("__all__")) {
                        //         onChange(propertyArray.map(p => p.value).join(","));
                        //     } else if (selected.length === propertyArray.length) {
                        //         // Auto-select All when all individual items are manually selected
                        //         onChange(propertyArray.map(p => p.value).join(","));
                        //     } else {
                        //         onChange(selected.join(","));
                        //     }
                        // };

                        // ====================================================================
                        // PERBAIKAN UTAMA: Logika handler yang baru dan lebih cerdas
                        // ====================================================================
                        const handleChange = (selectedOptions: OnChangeValue<OptionType, true>) => {
                            // Case 1: Pengguna menghapus semua pilihan
                            if (!selectedOptions || selectedOptions.length === 0) {
                                onChange("");
                                return;
                            }

                            const newSelectedValues = selectedOptions.map(opt => opt.value);
                            const wasAllSelected = isAllSelected;

                            // Case 2: Pengguna mengklik "All Properties" untuk memilih semua
                            if (!wasAllSelected && newSelectedValues.includes("__all__")) {
                                onChange(propertyArray.map(p => p.value).join(","));
                                return;
                            }

                            // Case 3: Semua properti sebelumnya terpilih, dan pengguna menghapus salah satu
                            // (baik itu "All Properties" atau properti individual)
                            if (wasAllSelected && selectedOptions.length < optionsWithAll.length) {
                                // Buang "__all__" dari daftar dan kirim sisanya
                                const remainingValues = newSelectedValues.filter(v => v !== "__all__");
                                onChange(remainingValues.join(","));
                                return;
                            }

                            // Case 4: Pengguna secara manual memilih semua properti individual
                            if (newSelectedValues.length === propertyArray.length) {
                                onChange(propertyArray.map(p => p.value).join(","));
                                return;
                            }

                            // Default: Perubahan biasa
                            onChange(newSelectedValues.join(","));
                        };

                        const displayValues = isAllSelected
                            ? optionsWithAll // Tampilkan "All Properties" dan semua properti
                            : propertyArray.filter(opt => selectedValues.includes(opt.value));

                        return (
                            <>
                                <Select
                                    isMulti
                                    options={optionsWithAll}
                                    value={displayValues}
                                    onChange={(newValue) => handleChange(newValue)}
                                    className={errors.property_id ? "is-invalid" : ""}
                                />
                                {errors.property_id && (
                                    <div className="invalid-feedback">
                                        {errors.property_id.message as string}
                                    </div>
                                )}
                            </>
                        );
                    }}
                />
            ) : (
                <Select isDisabled options={[]} placeholder="No properties available" />
            )}
        </div>
    );
};


export default PropertySelectComponent;